import styled from "styled-components";
import theme from "../theme/theme";
import NumberWIthLabelBelow from "../components/Base/NumberWIthLabelBelow";
import { numberFormatter } from "../utils";
const Wrapper = styled.ul`
  display: flex;
  padding: 20px 0;
  margin: 10px 0 30px;
  border: 1px solid ${theme.colors.primary};
  background-color: #fafeff;

  li {
    flex: 1;
    padding: 0 20px;
  }
  li:not(:last-child) {
    border-right: 1px solid ${theme.colors.gray};
  }

  .two-values {
    display: flex;
  }

  @media (max-width: 480px) {
    display: block;
  }
`;

const WrapperForMobile = styled.ul`
  display: flex;
  padding: 20px 15px;
  margin: 10px 0 30px;
  border: 1px solid ${theme.colors.primary};
  background-color: #fafeff;

  li {
    flex: 1;
    padding: 15px 20px;
  }

  li:not(:last-child) {
    border-bottom: 1px solid ${theme.colors.primary};
  }

  @media (max-width: 480px) {
    display: block;
    margin: 200px 0 30px;
  }
`;

const InvestmentHighlights = ({ data }) => {
  return (
    <>
      {window.screen.width > 480 ? (
        <Wrapper>
          <li>
            <NumberWIthLabelBelow
              dotColor={theme.colors.strongMarket}
              text={`${data?.strongMarketReturn || "0"}%`}
              label="Projected Annual Return"
            />
          </li>
          <li>
            <NumberWIthLabelBelow
              dotColor={theme.colors.avgMarket}
              text={`${data?.weekMarketReturn || "0"}%`}
              label="Average Market"
            />
          </li>
          <li>
            <NumberWIthLabelBelow
              text={`${data?.maxDrawdown || "0"} %`}
              label="Max Drawdown"
              infoIcon={true}
            />
          </li>
          <li className="two-values">
            <NumberWIthLabelBelow
              text={`${numberFormatter(data?.minEstimatedBalance) || "0"} - ${
                numberFormatter(data?.estimatedBalance) || "0"
              }`}
              label="Projected Value"
            />
          </li>
        </Wrapper>
      ) : (
        <WrapperForMobile>
          <li>
            <NumberWIthLabelBelow
              dotColor={theme.colors.strongMarket}
              text={`${data?.strongMarketReturn || "0"}%`}
              label="Projected Annual Return"
            />
          </li>
          <li>
            <NumberWIthLabelBelow
              dotColor={theme.colors.avgMarket}
              text={`${data?.weekMarketReturn || "0"}%`}
              label="Average Market"
            />
          </li>
          <li>
            <NumberWIthLabelBelow
              text={`${data?.maxDrawdown || "0"} %`}
              label="Max Drawdown"
              infoIcon={true}
            />
          </li>
          <li>
            <NumberWIthLabelBelow
              text={`${numberFormatter(data?.minEstimatedBalance) || "0"} - ${
                numberFormatter(data?.estimatedBalance) || "0"
              }`}
              label="Projected Value"
            />
          </li>
        </WrapperForMobile>
      )}
    </>
  );
};

export default InvestmentHighlights;
